export const cbiGuideDict = {
  en: {
    nextTopic: 'Next topic',
    citizenshipByInvestment: 'Citizenship by investment for your goals:',
    allGoals: 'All Goals',
    updated: 'Updated:',
    preparedByExpert: 'Material prepared by an expert',
  },
  de: {
    nextTopic: 'Nächstes Thema',
    citizenshipByInvestment:
      'Staatsbürgerschaft durch Investition für Ihre Ziele:',
    allGoals: 'Alle Ziele',
    updated: 'Aktualisiert:',
    preparedByExpert: 'Von einem Experten erstelltes Material',
  },
  ru: {
    nextTopic: 'Следующая тема',
    citizenshipByInvestment: 'Гражданство за инвестиции для ваших целей:',
    allGoals: 'Все цели',
    updated: 'Обновлено:',
    preparedByExpert: 'Материал подготовил эксперт',
  },
  tr: {
    nextTopic: 'Sonraki konu',
    citizenshipByInvestment: 'Yatırım yoluyla vatandaşlık, hedefleriniz için:',
    allGoals: 'Tüm Hedefler',
    updated: 'Güncellenmiş:',
    preparedByExpert: 'Uzman tarafından hazırlanmış materyal',
  },
  es: {
    nextTopic: 'Siguiente tema',
    citizenshipByInvestment: 'Ciudadanía por inversión para tus objetivos:',
    allGoals: 'Todos los objetivos',
    updated: 'Actualizado:',
    preparedByExpert: 'Material preparado por un experto',
  },
};
